import { createLifecycleFor } from "actions/account/collections";

export const POLLING_STARTED = "POLLING_STARTED";
export const POLLING_STOPPED = "POLLING_STOPPED";

export const { replace } = createLifecycleFor("flowStatus");

export const startPolling = id => ({ type: POLLING_STARTED, payload: id });
export const stopPolling = () => ({ type: POLLING_STOPPED });
